import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

// Dynamic active styling for content list based on one-third viewport line
window.addEventListener("load", function () {
  const policySection = document.getElementById("policy");
  if (!policySection) return;
  const sectionNodes = Array.prototype.slice.call(
    policySection.querySelectorAll(".repeater-item[id]")
  );
  const linkNodes = Array.prototype.slice.call(
    policySection.querySelectorAll('.content-list a[href^="#"]')
  );

  // 1.  new scroll triger that pins the left sidebar content list
  const policy = document.querySelector("#policy");
  const polictList = policy.querySelector(".content-list");
  const policyRepeater = policy.querySelector(".repeater");
  gsap.to(policyRepeater, {
    scrollTrigger: {
      trigger: "#policy",

      pin: polictList,
      start: "top top",
      end: "bottom bottom",
    },
  });

  // 2. find the active right section - and highlight its corresponding left list item

  // 3. add the scroll to functionality on the left list items

  if (!sectionNodes.length || !linkNodes.length) return;

  const idToLink = {};
  linkNodes.forEach(function (a) {
    const hash = a.getAttribute("href") || "";
    const id = hash.replace("#", "");
    if (id) {
      idToLink[id] = a;
    }
  });

  const setActive = function (id) {
    linkNodes.forEach(function (a) {
      a.classList.remove("text-orange", "font-medium");
      a.classList.add("text-sage");
    });
    const active = idToLink[id];
    if (active) {
      active.classList.remove("text-sage");
      active.classList.add("text-orange", "font-medium");
    }
  };

  const findCenteredSectionId = function () {
    const viewportLine = window.innerHeight / 3; // one-third from top
    let bestId = null;
    let bestDist = Infinity;

    for (let i = 0; i < sectionNodes.length; i++) {
      const el = sectionNodes[i];
      const rect = el.getBoundingClientRect();
      // Consider only sections that are at least partially in view
      if (rect.bottom < 0 || rect.top > window.innerHeight) continue;
      const centerY = rect.top + rect.height / 2;
      const dist = Math.abs(centerY - viewportLine);
      if (dist < bestDist) {
        bestDist = dist;
        bestId = el.id;
      }
    }
    // If none are in view (e.g., above first or below last), choose nearest by top distance
    if (!bestId) {
      let fallbackBest = null;
      let fallbackDist = Infinity;
      for (let i = 0; i < sectionNodes.length; i++) {
        const el = sectionNodes[i];
        const rect = el.getBoundingClientRect();
        const dist = Math.abs(rect.top - viewportLine);
        if (dist < fallbackDist) {
          fallbackDist = dist;
          fallbackBest = el.id;
        }
      }
      bestId = fallbackBest;
    }
    return bestId;
  };

  let ticking = false;
  const onScrollOrResize = function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      const id = findCenteredSectionId();
      if (id) setActive(id);
      ticking = false;
    });
  };

  // Initialize
  onScrollOrResize();

  // Handle hash on load
  const initialHash = (window.location.hash || "").replace("#", "");
  if (initialHash) setActive(initialHash);

  window.addEventListener("scroll", onScrollOrResize, {
    passive: true,
  });
  window.addEventListener("resize", onScrollOrResize);
});

// Smooth scroll for policy content-list anchors with header offset
window.addEventListener("load", function () {
  const headerBar = document.querySelector("header > div");
  const getHeaderOffset = function () {
    return headerBar ? headerBar.offsetHeight : 100;
  };

  const links = document.querySelectorAll('.content-list a[href^="#"]');
  if (!links.length) return;

  links.forEach(function (link) {
    link.addEventListener("click", function (e) {
      const hash = this.getAttribute("href");
      if (!hash || hash.length < 2) return;
      const target = document.getElementById(hash.substring(1));
      if (!target) return;
      e.preventDefault();

      const rect = target.getBoundingClientRect();
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const targetY = rect.top + scrollTop;
      const offset = getHeaderOffset() + 16; // small extra spacing

      window.scrollTo({
        top: targetY - offset,
        behavior: "smooth",
      });
      try {
        history.replaceState(null, "", hash);
      } catch (_) {}
    });
  });
});
